import moment from "moment";

// Company time = Damascus = fixed UTC+3 (Syria has no DST since Oct 2022).
// Final-version doc 2026-10-05, problem 4 (one-hour gap): every server
// timestamp and every "today" default goes through this module so the screen
// never depends on the browser/PC time zone. A fixed offset is used on
// purpose instead of a tz database: old tz data would still apply the
// abolished winter +02.
export const COMPANY_UTC_OFFSET_MINUTES = 180;

// "...T11:00:00.000000Z", "... 11:00:00+00:00", "...T11:00+0300"
const ZONED = /\d{2}:\d{2}(:\d{2}(\.\d+)?)?\s*([zZ]|[+-]\d{2}:?\d{2})$/;
// Naive server wall-clock strings ("2026-10-05 14:00:00") are Damascus time.
const NAIVE_FORMATS = [
  "YYYY-MM-DD HH:mm:ss.SSSSSS",
  "YYYY-MM-DD HH:mm:ss.SSS",
  "YYYY-MM-DD HH:mm:ss",
  "YYYY-MM-DD HH:mm",
  "YYYY-MM-DDTHH:mm:ss.SSSSSS",
  "YYYY-MM-DDTHH:mm:ss.SSS",
  "YYYY-MM-DDTHH:mm:ss",
  "YYYY-MM-DDTHH:mm",
  "YYYY-MM-DD",
];

// Returns a moment fixed at UTC+3 holding Damascus wall-clock fields, or null.
// - zoned string  -> same instant, shown at +03
// - naive string  -> taken as Damascus wall time (fields unchanged)
// - epoch ms      -> converted
// - date-only     -> that Damascus date at 00:00
// - Date / moment -> same instant, shown at +03
export function toCompanyMoment(value) {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  let m = null;
  if (moment.isMoment(value)) {
    m = value.clone();
  } else if (value instanceof Date) {
    m = moment.utc(value.getTime());
  } else if (typeof value === "number" || /^\d{10,13}$/.test(String(value).trim())) {
    let n = Number(value);
    if (n < 1e11) n *= 1000; // epoch seconds
    m = moment.utc(n);
  } else {
    const text = String(value).trim();
    if (ZONED.test(text)) {
      m = moment.parseZone(text);
    } else {
      const naive = moment.utc(text, NAIVE_FORMATS, true);
      return naive.isValid() ? naive.utcOffset(COMPANY_UTC_OFFSET_MINUTES, true) : null;
    }
  }

  return m && m.isValid() ? m.utcOffset(COMPANY_UTC_OFFSET_MINUTES) : null;
}

export function formatCompanyTime(value, format = "YYYY-MM-DD HH:mm", fallback = "-") {
  const m = toCompanyMoment(value);
  return m ? m.format(format) : fallback;
}

// moment.now is server-synced after login (util/index.js setMomentTime), so
// this is the server's instant shown at +03.
export function companyNow() {
  return moment().utcOffset(COMPANY_UTC_OFFSET_MINUTES);
}

export function companyToday(format = "YYYY-MM-DD") {
  return companyNow().format(format);
}

export default {
  COMPANY_UTC_OFFSET_MINUTES,
  toCompanyMoment,
  formatCompanyTime,
  companyNow,
  companyToday,
};
